import React, { useEffect, useState } from "react";

import { useSearchParams } from "react-router-dom";

import ButtonGroup from "@mui/material/ButtonGroup";
import Button from "@mui/material/Button";

const TimeControl = (props) => {
  const [time, setTime] = React.useState("");
  const [loading, setLoading] = React.useState(true);

  let [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    setLoading(true);
    if (searchParams.get("time")) {
      const value = searchParams.get("time");
      setTime(value);
    } else {
      setTime("1");
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    if (!loading) {
      let params = new URLSearchParams(searchParams);
      if (time.length > 0) {
        if (params.get("time")) {
          if (params.get("time") !== time) {
            params.delete("time");
            params.append("time", time);
            setSearchParams(params);
          }
        } else {
          params.append("time", time);
          setSearchParams(params);
        }
      } else {
        if (params.get("time")) {
          params.delete("time");
          setSearchParams(params);
        }
      }
    }
  }, [time, searchParams, setSearchParams]);

  return (
    <div
      style={{
        width: "100%",
        marginTop: "5px",
        display: "flex",
        height: "40px",
        flexDirection: "row-reverse",
      }}
    >
      <ButtonGroup
        size="small"
        variant="outlined"
        aria-label="outlined primary button group"
        style={{ marginRight: "10px" }}
      >
        <Button
          variant={time == "1" ? "contained" : "outlined"}
          onClick={() => {
            setTime("1");
          }}
        >
          1 Day
        </Button>
        <Button
          variant={time == "3" ? "contained" : "outlined"}
          onClick={() => {
            setTime("3");
          }}
        >
          3 Days
        </Button>
        <Button
          variant={time == "30" ? "contained" : "outlined"}
          onClick={() => {
            setTime("30");
          }}
        >
          1 Month
        </Button>
        <Button
          variant={time == "90" ? "contained" : "outlined"}
          onClick={() => {
            setTime("90");
          }}
        >
          3 Months
        </Button>
        <Button
          variant={time == "180" ? "contained" : "outlined"}
          onClick={() => {
            setTime("180");
          }}
        >
          6 Months
        </Button>
        <Button
          variant={time == "365" ? "contained" : "outlined"}
          onClick={() => {
            setTime("365");
          }}
        >
          1 Year
        </Button>
        <Button
          variant={time == "730" ? "contained" : "outlined"}
          onClick={() => {
            setTime("730");
          }}
        >
          2 Years
        </Button>
        <Button
          variant={time == "1825" ? "contained" : "outlined"}
          onClick={() => {
            setTime("1825");
          }}
        >
          5 Years
        </Button>
        <Button
          variant={time == "3650" ? "contained" : "outlined"}
          onClick={() => {
            setTime("3650");
          }}
        >
          10 Years
        </Button>
        <Button
          variant={time == "max" ? "contained" : "outlined"}
          onClick={() => {
            setTime("max");
          }}
        >
          Max
        </Button>
      </ButtonGroup>
    </div>
  );
};

export default TimeControl;
